import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { extras } from '../data/volumes';
const questions = ['What am I actually observing?', 'What does this mean within the case?', 'What should I reevaluate?', 'What tool should I use next?'];
export function ExtrasSection() {
  return <section className="w-full bg-navy-900 py-14 sm:py-20" data-id="element-110" data-mp="o0fw0ublnypf">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-111" data-mp="12y897ftocb0g">
        <SectionHeading tone="dark" title={<>
              📲 And you’ll also get{' '}
              <em className="not-italic text-gold-400" data-id="element-113" data-mp="1brv1gvyoaw4w">instant access to:</em>
            </>} data-id="element-112" data-mp="12wowu0b52k3y" />

        <ul className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-114" data-mp="17pi1ko6lxsg1">
          {extras.map(extra => <li key={extra.title} className="flex h-full flex-col rounded-2xl border border-gold-500/25 bg-navy-800 p-5" data-id="element-115" data-mp="1loq1xkeib6lt">
              <span className="text-3xl leading-none" aria-hidden="true" data-id="element-116" data-mp="1gollfudlmbvl">
                {extra.icon}
              </span>
              <h3 className="mt-3.5 text-[15px] font-extrabold uppercase tracking-wide text-gold-300" data-id="element-117" data-mp="cmfk8cfsg09s">
                {extra.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-cream-100/75" data-id="element-118" data-mp="hkqw0spn8kun">
                {extra.description}
              </p>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl border border-gold-500/30 bg-navy-950 p-6 sm:p-8" data-id="element-119" data-mp="qlxe367xy3q0">
          <h3 className="text-center font-display text-[22px] font-bold leading-tight text-cream-100 sm:text-3xl" data-id="element-120" data-mp="vkryudpgy2cr">
            Whatever occlusal case makes you hesitate…
          </h3>
          <p className="mt-4 text-center text-[14.5px] text-cream-100/70" data-id="element-121" data-mp="15bwbv7vl3d4y">
            You won’t have to rely only on:
          </p>
          <p className="mt-2 text-center font-display text-[20px] font-bold italic text-clinical-red sm:text-2xl" data-id="element-122" data-mp="19esv90sy7d9y">
            “Where is the mark?”
          </p>
          <p className="mt-6 text-center text-[14.5px] text-cream-100/70" data-id="element-123" data-mp="3aeo3x73lmv6z">
            You’ll have a structured pathway to ask:
          </p>
          <ul className="mx-auto mt-4 grid w-full max-w-md gap-2.5" data-id="element-124" data-mp="36fp0jqxin6hn">
            {questions.map(question => <li key={question} className="rounded-xl border-l-4 border-gold-500 bg-navy-800 px-4 py-3 text-[14.5px] font-semibold text-cream-100" data-id="element-125" data-mp="3k73li3azhhrc">
                {question}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-9 w-full max-w-md" data-id="element-126" data-mp="3p42f8kqqjmp0">
          <CTAButton label="I want access to the complete system" subline="Instant access · One-time payment of $27 USD" data-id="element-127" data-mp="6yz4aje38ggo" />
        </div>
      </div>
    </section>;
}